// hooks/usePusher.js
import { useEffect, useState } from 'react';
import { usePusher } from '../components/pusher/pusher-provider';

const usePusherChannel = (customerId: string | number, eventName: string) => {
  const [data, setData] = useState<any>(null);
  const echo = usePusher();

  useEffect(() => {
    if (!echo || !customerId || !eventName) {
      if (process.env.NODE_ENV === 'development')
        console.log('Pusher setup missing:', { echo: !!echo, customerId, eventName });
      return;
    }

    // Format the channel name with customerId
    const channelName = `App.Models.Customer.${customerId}`;
    if (process.env.NODE_ENV === 'development')
      console.log('Setting up Pusher channel:', { channelName, eventName });

    // Subscribe to the specified channel using Laravel Echo
    const channel = echo.private(channelName);

    // DEBUG: Check if channel subscription worked
    channel.subscribed(() => {
      if (process.env.NODE_ENV === 'development')
        console.log('✅ CHANNEL SUBSCRIBED:', channelName);
    });

    channel.error((error: any) => {
      if (process.env.NODE_ENV === 'development')
        console.log('❌ CHANNEL ERROR:', { channelName, error });
    });

    // DEBUG: Listen to ALL events on this channel
    (channel as any).listenToAll((eventName: string, eventData: any) => {
      if (process.env.NODE_ENV === 'development')
        console.log('🔥 ALL EVENTS DEBUG:', {
          receivedEventName: eventName,
          expectedEventName: eventName,
          eventData,
          channelName,
        });
    });

    // Listen for the specified event
    channel.listen(eventName, (eventData: any) => {
      if (process.env.NODE_ENV === 'development')
        console.log('✅ SPECIFIC EVENT MATCHED:', { eventName, eventData });

      try {
        setData(eventData);
      } catch (error) {
        if (process.env.NODE_ENV === 'development')
          console.error('Failed to parse event data:', error);
      }
    });

    // Cleanup on unmount
    return () => {
      if (process.env.NODE_ENV === 'development')
        console.log('Cleaning up Pusher channel:', { channelName, eventName });
      channel.stopListening(eventName);
      echo.leave(channelName);
    };
  }, [echo, customerId, eventName]);

  return data;
};

export default usePusherChannel;
